import { useCallback, useState } from 'react';

export function useSidebarState() {
  const [state, setState] = useState(initialState);

  const openSidebar = useCallback(
    () =>
      setState(current => ({
        ...current,
        isOpen: current.isVisible && true,
      })),
    []
  );

  const closeSidebar = useCallback(
    () =>
      setState(current => ({
        ...current,
        isOpen: false,
      })),
    []
  );

  const showSidebar = useCallback(
    () =>
      setState(current => ({
        ...current,
        isVisible: true,
      })),
    []
  );

  const hideSidebar = useCallback(
    () =>
      setState(current => ({
        ...current,
        isVisible: false,
      })),
    []
  );

  const setSidebarBack = useCallback(
    () =>
      setState(current => ({
        ...current,
        isMenu: false,
      })),
    []
  );

  const setSidebarMenu = useCallback(
    () =>
      setState(current => ({
        ...current,
        isMenu: true,
      })),
    []
  );

  return {
    ...state,
    openSidebar,
    closeSidebar,
    showSidebar,
    hideSidebar,
    setSidebarBack,
    setSidebarMenu,
  };
}

type State = {
  isOpen: boolean;
  isMenu: boolean;
  isVisible: boolean;
};

const initialState: State = {
  isMenu: true,
  isOpen: false,
  isVisible: false,
};
